export const recoverableLoaderMessages = {
  en: {
    failedToFetch: 'Failed to fetch data.',
    tryAgain: 'Try again',
  },
};
